import { t } from "i18next"
import ellipse from '../../assets/ellipse.svg'

export function ExperienceItem({
  first,
  last,
  expId,
  company,
  startTime, 
  endTime, 
  tags
}: {
  first: boolean,
  last: boolean,
  expId: string,
  company: string,
  startTime: number[], 
  endTime: number[], 
  tags: string[] 
}) {
  return(
    <div className={first? "experience experience--first" : last? "experience experience--last": "experience"}>
        <img src={ellipse} alt=""></img>
        <h3><span>{t(`${expId}.title`)},</span> <span className="nowrap">{company}</span> <span className="nowrap">{startTime[0]} / {startTime[1]} - {endTime[0]} / {endTime[1]}</span></h3>
        <div className="tags flex flex-wrap">
          {tags.map((t,i)=> {
            return(
              <span key={i} className="tag">{t}</span>
            )
          })}
        </div>
        <p className="optional-content">{t(`${expId}.description`)}</p>
      </div>
  )
  
}